<div class="header">
  <div class="title">
    <div class="title-text">Laser</div>
  </div>
  <span class="message">* populated from PatientNow</span>
</div>
<hr class="divider" />
<fb-laser-treatment-control-display [labels]="labels()" />
<hr class="divider" />
<div class="action">
  <rx-icon name="icon-circle-plus-2" class="action-icon" />
  <span class="action-label">Add Laser</span>
</div>
